<template>
  <transition>   
     <!--name="slide-fade" <div class="back-drop-black"> 
  need to add this class   "back-drop-black "
     </div> -->
    <div v-if="search!=null" class="center-content ">
       <!-- <div v-if="lsCountryRoute!=null" >
      <pre class="language-json"><code>{{ lsCountryRoute  }}</code></pre>
      </div> -->
      <!-- <div class="back-drop-black"> -->
<!--   need to add this class   "back-drop-black " v-c-emit-root-event:toggle_backdrop-->
    <!-- </div> -->
      <!-- <div class="book-option-wrapper">
        <div class="booking-option" >
          <div class="img">
            <img src="@imgPath/img/svg/icons/take-off.svg" width="17px" />
          </div>
          <div class="text">{{$t('searchPage.headerFlight')}}</div>
        </div>
      </div> -->
      <div class="flight-search-wrapper" :class="{ mlcity_wrap : isMLSearch}" @click="isPaxViewOpen=false">
        <div class="search-option">
          <cRadioButton 
            v-for="tripObj in jTypeTabs"
            :key="'trip'+tripObj.code"
            :name="tripObj.code"
            :value="tripObj.code"
            :label="tripObj.name"
            v-on:input="onChangeTripCategory(tripObj)"
            rules="required"
            :selValue="jTypeTabs[search.trip-1]"
          />

<!--          <div class="ml-add-btn-wrap" v-if="isMLSearch" >-->
<!--            <div class="btn-wrap add">-->
<!--              <span>Add another flight</span>-->
<!--            </div>-->
<!--            <div class="btn-wrap remove">-->
<!--             <span>Remove flight</span>-->
<!--            </div>-->
<!--          </div>-->
        </div>

        <div class="main-search">

           <cMLSearch v-if="isMLSearch" :searchMlObj="search" :ref="'cMLSearch'"/>
           
          <div v-else class="route-name-wrapper">
           
          <div class="place">
            <div class="form">
              <label class="typo__label">{{$t('searchPage.from')}}</label>
              <multiselect
                :allow-empty="false"
                :showLabels="false"
                :clearOnSelect="false"
                v-model="search.route[0].from"
                :options="lsCountryRoute"
                :multiple="false"
                group-values="routeList"
                group-label="country"
                :group-select="false"
                :placeholder="$t('searchPage.searchPlaceHolder')"
                track-by="depcode"
                v-on:input="getArrivalRoutes"
                v-on:close="triggerArrCityPicker"
                v-on:open="triggerFlightDatePicker"
                ref="fromCityPicker"
                :searchable="true"
                :custom-label="cityPickCustomeLabel"
                @search-change="addCssClass()"
              >
                <template
                  slot="singleLabel"
                  slot-scope="{ option }"
                >{{ option.depcode.city}} ({{option.depcode.airportcode}})</template>
                <template slot="option" slot-scope="props">
                  <div>
                    <span v-if="props.option.$isLabel">{{ props.option.$groupLabel.value }}</span>
                    <span v-else>
                      {{ props.option.depcode.city}}
                      <strong
                        v-if="props.option.depcode"
                        class="right"
                      >{{ props.option.depcode.airportcode }}</strong>
                    </span>
                  </div>
                </template>
                <span slot="noResult"><strong>{{ $t("noMatchFound.noMatchFound") }}</strong></span>
              </multiselect>
            </div>
            <div class="center-icon" @click="rotate()">
              <img src="@imgPath/img/png/flight.png" alt />
              <img src="@imgPath/img/png/flight-round.png" alt id="rotate-icon" :class="{'re_rotate' : isFlIconRotate}"/>
            </div>
            <div class="to">
              <label class="typo__label">{{$t('searchPage.to')}}</label>
              <multiselect 
                :allow-empty="false"
                :showLabels="false"
                :clearOnSelect="false"
                v-model="search.route[0].to"
                :options="lsArrival"
                :multiple="false"
                group-values="routeList"
                group-label="country"
                :group-select="false"
                :placeholder="$t('searchPage.searchPlaceHolder')"
                track-by="depcode"
                v-on:input="assignArrToSearch(search.route[0].to)"
                v-on:open="triggerDepCityPicker"
                v-on:close="openDatePicker"
                ref="toCityPicker"
                :searchable="true"
                :custom-label="cityPickCustomeLabel"
                @search-change="addCssClass()"
              >
                <template
                  slot="singleLabel"
                  slot-scope="{ option }"
                >{{ option.depcode.city}} ({{option.depcode.airportcode}})</template>
                <template slot="option" slot-scope="props">
                  <div>
                    <span v-if="props.option.$isLabel">{{ props.option.$groupLabel.value }}</span>
                    <span v-else>
                      {{ props.option.depcode.city}}
                      <strong
                        v-if="props.option.depcode"
                        class="right"
                      >{{ props.option.depcode.airportcode }}</strong>
                    </span>
                  </div>
                </template>
                <span slot="noResult"><strong>{{ $t("noMatchFound.noMatchFound") }}</strong></span>
                <span slot="noOptions">{{search.route&&search.route[0]&&search.route[0].from?$t('searchPage.noArrivalsFound'):$t('searchPage.selectDeparture')}}</span>
              </multiselect>
            </div>
          </div>
          <div class="date" :class="{'oneway' : search.trip!=jTypeTabs[1].code}" @click="closePaxView()">
            <label class="typo__label depart">{{$t('searchPage.journeyDate')}}</label>
            <label class="typo__label return" v-if="search.trip==jTypeTabs[1].code">{{$t('searchPage.return')}}</label>
            <!-- <flightDatePicker            
              v-if="isDatePicShow"
              :startingDateValue="new Date(search.route[0].date)"
              :endingDateValue="search.trip==jTypeTabs[1].code?new Date(search.route[1].date):null"
              :hoveringTooltip="false"
              :displayClearButton="false"
              format="dddd, MMM DD"
              @checkInChanged="getFromDate"
              @checkOutChanged="getToDate"
              :singleDaySelection="search.trip==jTypeTabs[1].code?false:true"
              :i18n="assigni18nObjByLang()"
              ref="flightDatePicker"             
            /> -->
                <!-- :startingDateValue="new Date(search.route[0].date)" -->
<!-- @click.native="onClickDatePicker" -->
              <HotelDatePicker 
                v-if="isDatePicShow"
                 :showYear="true"
                 :startingDateValue="search.trip==jTypeTabs[1].code?new Date(search.route[0].date):null"
                :endingDateValue="search.trip==jTypeTabs[1].code?new Date(search.route[1].date):null"
                :hoveringTooltip="false"
                :displayClearButton="false"
                format="dddd, MMM DD"
                @check-in-changed="getFromDate"
                @check-out-changed="getToDate"
                :singleDaySelection="search.trip==jTypeTabs[1].code?false:true"
                :i18n="assigni18nObjByLang()"
                ref="flightDatePicker"
                :minNights="search.trip==jTypeTabs[1].code?0:1"
                
                
              />
              <!-- :enableCheckout="search.trip==jTypeTabs[1].code?
                true:false" -->
<!-- :closeDatepickerOnClickOutside="false" -->
          </div>
          </div>
         
          <div class="citizen place" id="citizen">
            <div class="mob-w-100">
              <label >{{$t('searchPage.citizenLabel')}}</label>
              <multiselect
                track-by="code"
                :allow-empty="false"
                :showLabels="false"
                v-model="citizenObj"
                :options="lsCitizenCategory"
                :placeholder="$t('searchPage.select')"
                :group-select="false"
                @select="onChangedCitizen"
                :searchable="false"

              >
                <template slot="singleLabel" slot-scope="{ option }">{{ option.name}}</template>
                <template slot="option" slot-scope="props">
                  <div>
                    <span>{{ props.option.name}}</span>
                  </div>
                </template>
                <span slot="noResult"><strong>{{ $t("noMatchFound.noMatchFound") }}</strong></span>
              </multiselect>
            </div>
          </div>
           <div class="currency place" id="currency">
            <cOrgCurrencyDp
              v-if="GET_ORG_CURRENCY_RES"
              v-on:input="onCurrencyChange"
              :selValue="search.currency"
              :label="$t('searchPage.currName')"
              :ctrlCode="'id'"
              :isAllowEmpty="false"
              :isShowCode="true"
              :isMultiple="false"
              :isSearchable="false"
              :url="getOrgCurrencyServiceURL()"
              rules="required"
              :defaultCurrency ="defaultCurrencyCode"
            />
          </div>
          <div @click.stop="onTogglePaxView" class="passagers">
            <label class="d-flex"><span>
              {{$t('searchPage.paxHeading')}}
            </span></label>
            <div
              class="value"
              id="passager-drop"
            >
             <span v-if="search.pax.adultCount"> 

              {{getPaxCount()}} 
             </span>
             <span>{{getPaxDisplayText(getPaxCount())}}</span>

            
            <!-- {{search.pax.adultCount}} {{$t('searchPage.adult')}}
            <span v-if="search.pax.childCount">              
              ,{{' '+search.pax.childCount}} {{$t('searchPage.child')}}
              </span>
              <span v-if="search.pax.infantCount">
              ,{{' '+search.pax.infantCount}} {{$t('searchPage.infant')}}
              </span> -->
              </div>
          </div>
<div class="pax-wrap" :class="{'d-none remove':!isPaxViewOpen}" >

<!--<div class="pax-wrap" :class="{' remove':!isPaxViewOpen}" :style="!isPaxViewOpen ? 'display:none': ###setTimeout for 1 sec###''">-->
          <div   class="passager-drop">
<!--              <div class="backdrop-date">-->

<!--            </div>-->
            <div  @click.stop="isPaxViewOpen=true,closeFlightDatePicker()" class="content">
            <div class="title">
              <CRow class="title">
           
                <span> {{$t('searchPage.paxHeading')}}</span>
            <cHelpTip :content="$t('helpTip.cSearchPassngr')"></cHelpTip>

              </CRow>
             

            </div>
            <div class="des">{{$t('searchPage.paxDesc')}}</div>

             <CAlert color="info" v-if="(search.pax.adultCount+search.pax.childCount+search.pax.infantCount)>=9">{{$t('searchPage.maxPax')}}
    </CAlert>
            <div class="category">
              <div class="option">
                <div class="left">
                  <div class="sub-title">{{$t('searchPage.adult')}}</div>
                  <div class="sub-dec">{{$t('searchPage.above')+' '+12+' '+$t('searchPage.years')}} </div>
                </div>

                <div class="right">
                  <number-input
                  
                    v-model="search.pax.adultCount"
                    :min="1"
                    :max="search.pax.adultCount+getMaxPaxCount()"
                    size="small"
                    inline
                    center
                    controls
                     :inputtable="false"
                  ></number-input>
                </div>
              </div>
              <div class="option">
                <div class="left">
                  <div class="sub-title">{{$t('searchPage.child')}}</div>
                  <div class="sub-dec">2-12 {{$t('searchPage.years')}}</div>
                </div>
                <div class="right">
                  <number-input
                    v-model="search.pax.childCount"
                    :min="0"
                    :max="search.pax.childCount+getMaxPaxCount()"
                    size="small"
                    inline
                    center
                    controls
                     :inputtable="false"
                  ></number-input>
                </div>
              </div>
              <div class="option">
                <div class="left">
                  <div class="sub-title">{{$t('searchPage.infants')}}</div>
                  <div class="sub-dec">{{$t('searchPage.below')+' '+2+' '+$t('searchPage.years')}}</div>
                </div>
                <div class="right">
                  <number-input
                 
                          v-model="search.pax.infantCount"
                          :min="0"
                          :max="(search.pax.adultCount+search.pax.childCount+search.pax.infantCount)<9?search.pax.adultCount:search.pax.infantCount+getMaxPaxCount()"
                          size="small"
                          inline
                          center
                          controls
                           :inputtable="false"
                  ></number-input>
                </div>
              </div>
<!--              <div class="option">-->
<!--                <div class="left">-->
<!--                  <div class="sub-title">{{$t('searchPage.infant')}}</div>-->
<!--                  <div class="sub-dec">{{$t('searchPage.below')}} 2 {{$t('searchPage.years')}}</div>-->
<!--                </div>-->
<!--               -->
<!--              </div>-->
            </div>
            </div> 
          </div>
            </div>

          <div @click="emitSearchObj" class="search-btn">
            <span class="dot" ></span>
<!--            <img src="@imgPath/img/svg/icons/search-icon.svg" alt />-->
            <span>{{$t('searchPage.searchBtn')}}</span>
          </div>
        </div>
      </div>

<!--      <div :show="alertValue!=null"  class="search_error_message">{{}}</div>-->
      <!-- <div :show="alertValue!=null" v-if="alertValue=='Invalid From/To route'" class="search_error_message">Please Enter Valid route</div>  
    </div> -->
    <!-- v-if='alertValue==$t("searchPage.routeInvalid")' -->
      <div  @click='showAlertMessage(null,true)' v-if="alertValue" :show="alertValue!=null"  class="search_error_message">{{alertValue}}
            <div class='align-alert' @click.stop='showAlertMessage(null,true)'>
                 <CIcon name="cilXCircle">

                 </CIcon>
               </div>
        </div>  
    </div>

    <!-- <pre class="language-json"><code>{{ search.route[0].from  }}</code></pre> -->
    <!-- {{ search.route[0].date|formatDate("YYYY MM DD")}} -->
    <!-- <pre class="language-json"><code>{{ search  }}</code></pre> -->
    <!-- <pre class="language-json"><code>{{ tempRoutesGrpByList  }}</code></pre> -->
    <!-- {{search}} -->

    <!-- <div class="booking-option-wrapper">
          <div class="recent-search">
            <div class="head">

            </div>
            <div class="body">
              <div class="searched-data">
                <div class="title">
                  <span>Hong Kong</span>
                  <img src="@imgPath/img/svg/icons/Buisness_Registration_Number.svg">
                  <span>Chennai</span>
                </div>
              </div>
            </div>

    </div>-->
  </transition>
</template>

<script>
import Vue from 'vue'
import { handleJWT, getErrorAlertValue} from "../../util/util";

import {getFlightSearchHisFromLocal,setFlightSearchHisToLocal}from './../../applocalstorage/localStorage'
import VueNumberInput from '@chenfengyuan/vue-number-input';
import {
  dateFunctions,
  getDiffBtwDates,
  addDays,
  formatDate
} from "../../util/date/dateFunctions";
import cCurrencyDropDown from "../currency/cCurrencyDropDown";

import {
  TRIP,
  PAX,
  PAX_COUNT,
  LOCAL_STORAGE_KEYS,
  CITIZEN,TOAST_TYPE,ALL_CLIENT_CODE
} from "../../util/constants.js";
import cRadioButton from "../form/cRadioButton";
import cOrgCurrencyDp from "../currency/cOrgCurrencyDp";

import Logger from "../../services/logger";
import apiGetRoutes from "../../services/apiGetRoutes.js";
// import apiSearchResult from "../../../../services/apiSearchResult.js";

import { VALIDATE_SUCCESS_RES, getErrorMessage } from "@/util/apiValidate.js";
import router ,{navigate,goBack, updateDataEdited }from "../../router/index";

import {
  LOG_TYPE,
  FILE_NAME,
  HTTP_CODES,
  API_VALUES
} from "../../config/API_DATA";
import { COMPONENT_NAME, PATHNAME } from "../../util/constants";
import BaseConfiguration from "../../config/base.js";
import SERVICE_URL from "../../config/API_DATA";
import cMLSearch from "../multiCity/search/cMLSearch";
import { i18n } from "../../plugins/i18n.js";
//import flightDatePicker from "vue-flight-datepicker";
import HotelDatePicker from 'vue-range-datechooser'
import Multiselect from "vue-multiselect";
import { GroupByList, cloneData,cloneDeep } from "../../util/util.js";
import { mapGetters, mapActions } from "vuex";
Vue.use(VueNumberInput);
import cHelpTip from "../../components/cHelpTip"

export default {
  name: COMPONENT_NAME.C_SEARCH,
  components: {
   // flightDatePicker,
   HotelDatePicker,
    Multiselect,
    cCurrencyDropDown,
    cOrgCurrencyDp,
    cRadioButton,
    cMLSearch,
    cHelpTip
  },
  props: {
    isBackdropAdded :{
       type: Boolean,
       default: false
    },
    searchObject: {
      type: Object,
      default: null
    },
    isParentCompTriggered:{
      type:Boolean,
      default:false
    }
  },
  data: () => ({
     clientCode:BaseConfiguration.clientCode,
      allClientCode:ALL_CLIENT_CODE,
    isMLSearch:false,
    citizenObj: null,
    isFlIconRotate: false,
    isPaxViewOpen: false,
    isDatePicShow: true,

    lsCitizenCategory: [
      {
        name: i18n.tc('searchPage.yes'),
        code: "Y"
      },
      {
        name: i18n.tc('searchPage.no'),
        code: "N"
      }
    ],

    lsAirlineClass: [
      {
        name: i18n.tc('searchPage.economy'),
        code: "E/PE"
      },
      {
        name: i18n.tc('searchPage.buisness'),
        code: "B"
      },
      {
        name: i18n.tc('searchPage.buisFirst'),
        code: "B/F"
      },
      {
        name:  i18n.tc('searchPage.premium'),
        code: "PE"
      },
      {
        name:  i18n.tc('searchPage.first'),
        code: "F"
      }
    ],

    jTypeTabs: [
      {
        name:  i18n.tc('searchPage.oneWay'),
        code: TRIP.ONE_WAY
      },
      {
        name: i18n.tc('searchPage.roundTrip'),
        code: TRIP.ROUND_TRIP
      },
      {
        name:  i18n.tc('searchPage.multiCity'),
        code: TRIP.MULTI_CITY
      },

      
    ],
     lsCitizen: {
     CITIZEN: {
        name: i18n.tc('searchPage.citizenName'),
        code: BaseConfiguration.defaultCountryValue
    },
     FOREIGNER :{
        name: i18n.tc('searchPage.foreigner'),
        code: CITIZEN.FOREIGNER.code
    },
    //  CANADIAN :{
    //     name: i18n.tc('searchPage.citizenName'),
    //     code: CITIZEN.CANADIAN.code
    // },
},

    // alertValue: null,
    lsCountryRoute: [],
    lsArrival: [],
    routesResponse: null,
    defaultCurrencyCode: null, 

   //searchHistory: [],
    //isClearSearchHistory: false,
    // showAlert: false,
    alertValue: null,
    currentAlertCounter: 0,

    search: {
      trip: BaseConfiguration.defaultTrip,
      route: [
        {
          from: null,
          to: null,
          date: new Date()
        }
      ],
      class: null,
      pax: {
        adultCount: 1,
        childCount: 0,
        infantCount: 0
      },
      citizen: null,
      currency: null
    },
    active: false,
  
    isSavedActiveDatePickVal:false
  }),
  watch:{
    isParentCompTriggered(newVal , oldVal){
      if(this.isPaxViewOpen)
        {
          this.isPaxViewOpen=false;
        }
    },
    isBackdropAdded(newVal , oldVal){
        if(newVal===false)
        {
          this.closeAllPopups();
        }
        // if(this.$refs.flightDatePicker.isOpen==false&&this.search.route[1].date==null&&this.search.route[0].date)
        // {
        //    this.getCheckOut();
        // }

    }
  },

  methods: {
    ...mapActions("sCSearch", ["SET_ROUTES_OBJ"]),
   
        ...mapActions("sCSearch",{
          SET_ARR_LS:"SET_ARR_LS",
          SET_ROUTES_OBJ:"SET_ROUTES_OBJ",
          SET_SEARCH_OBJ:"SET_SEARCH_OBJ"

        } ),

   ...mapActions("sCMultiCitySearch", {
      SET_ML_SEARCH_OBJ: "SET_ML_SEARCH_OBJ",
      SET_IS_ML_SEARCH:"SET_IS_ML_SEARCH"
     
    }),

   
    onTogglePaxView() {
        try {
          if(BaseConfiguration.isDebug) console.log("onTogglePaxView");
          this.isPaxViewOpen=!this.isPaxViewOpen;
          this.onToggleBackdrop(true);
          this.closeFlightDatePicker();
        } catch (err) {
                let body = Logger.buildRequest(
                  COMPONENT_NAME.C_SEARCH,
                  "error in onTogglePaxView",
                  err.toString(),
                  "onTogglePaxView",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
          
        }, 
    closeFlightDatePicker() {
        try {
          if(BaseConfiguration.isDebug) console.log("closeFlightDatePicker");
          
          if (this.$refs.flightDatePicker&&this.$refs.flightDatePicker.isOpen) {
          this.$refs.flightDatePicker.isOpen = false;
        }else if(this.$refs.cMLSearch&&this.$refs.cMLSearch.$refs&&this.$refs.cMLSearch.$refs.flightDatePicker){
          for(let i=0;i<this.$refs.cMLSearch.$refs.flightDatePicker.length;i++){
            if(this.$refs.cMLSearch.$refs.flightDatePicker[i]&&this.$refs.cMLSearch.$refs.flightDatePicker[i].isOpen){
              this.$refs.cMLSearch.$refs.flightDatePicker[i].isOpen=false;
            }
          }
        }
    
        } catch (err) {
                let body = Logger.buildRequest(
                 COMPONENT_NAME.C_SEARCH,
                  "error in closeFlightDatePicker",
                  err.toString(),
                  "closeFlightDatePicker",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
         
        }, 
  // checkOut(){
  //           return addDays(new Date(search.route[0].date),7);
  // },

  // getCheckOut(){
  //   // if(this.$refs.flightDatePicker.isOpen==false){
  //   //    this.search.route[1].date= addDays(new Date(this.search.route[0].date),7);
  //   //     this.$refs.flightDatePicker.checkOut= this.search.route[1].date;
  //   //      this.isDatePicShow=false;
        
  //   //         let that = this;
  //   //         setTimeout(function() {
  //   //         that.isDatePicShow = true;
  //   //       },100);
  //   // }
  //   console.log("checkout");
  // },
     
     getPaxCount() {
         let retValue;
         try {
           if(BaseConfiguration.isDebug) console.log("getPaxCount");
        retValue= Number(this.search.pax.adultCount)+Number(this.search.pax.childCount)+Number(this.search.pax.infantCount);
         if(retValue==0){
           retValue='';
         }
         } catch (err) {
                 let body = Logger.buildRequest(
                   COMPONENT_NAME.C_SEARCH,
                   "error in getPaxCount",
                   err.toString(),
                   "getPaxCount",
                   LOG_TYPE.ERROR
                 );
                 Logger.getResponse(body);
               }
           return retValue;
         }, 
     
     getPaxDisplayText(pPaxCount) {
        let retValue;
         try {
           if(BaseConfiguration.isDebug) console.log("getPaxDisplayText");
          if(pPaxCount==1){
            retValue=this.$t('searchPage.passenger')
          }else {
            retValue=this.$t('searchPage.passengers')
          }
     
         } catch (err) {
                 let body = Logger.buildRequest(
                   COMPONENT_NAME.C_SEARCH,
                   "error in getPaxDisplayText",
                   err.toString(),
                   "getPaxDisplayText",
                   LOG_TYPE.ERROR
                 );
                 Logger.getResponse(body);
               }
           return retValue;
         }, 
 
    getMaxPaxCount(){
      let count=0;
      if(this.search.pax.adultCount<this.search.pax.infantCount){
        this.search.pax.infantCount=this.search.pax.adultCount;
      }
      if(this.search.pax.adultCount+this.search.pax.childCount+this.search.pax.infantCount<9)
      {
   count=  (9-(this.search.pax.adultCount+this.search.pax.childCount+this.search.pax.infantCount))+this.search.pax.adultCount+this.search.pax.childCount+this.search.pax.infantCount
      }
     
       return count;
    },
    closeAllPopups(){
      this.isPaxViewOpen = false;
      //this.$refs.flightDatePicker.isOpen = false;
      if(this.$refs.fromCityPicker&& this.$refs.toCityPicker){
   this.$refs.fromCityPicker.deactivate();
      this.$refs.toCityPicker.deactivate();
      }
   
    },
    closePaxView(){
      this.isPaxViewOpen = false;
    },
    onToggleBackdrop(open){
              if (BaseConfiguration.isDebug) console.log("onToggleBackdrop");

     this.$root.$emit("toggle_backdrop",open);

    },
    cityPickCustomeLabel(option) {
      return `${option.depcode.city} — [${option.depcode.airportcode}]`;
    },
    ///to change class of city picker    
    addCssClass() {
      //
      try {
        if (BaseConfiguration.isDebug) console.log("addCssClass");

        let countryTitleLIst = document.getElementsByClassName(
          "multiselect__option--disabled"
        );
        setTimeout(() => {
          for (let index = 0; index < countryTitleLIst.length; index++) {
          const element = countryTitleLIst[index];
          element.parentNode.classList.add("active");
        }
        },100);
        
      } catch (error) {
        //ignore 
      }
    },
    formatSearchObjCitizen: function(pSearchObj) {
      try {
        if (BaseConfiguration.isDebug) console.log("formatSearchObjCitizen");
        let retValue = pSearchObj;
        if (this.citizenObj) {
          if (
            this.citizenObj.code ==
            this.lsCitizenCategory[TRIP.ONE_WAY - 1].code
          ) {
            // if(this.clientCode!=this.allClientCode.AZ) {
            retValue.citizen = this.lsCitizen.CITIZEN;
            // }else{
            //   retValue.citizen = this.lsCitizen.CANADIAN;
            // }
          } else {
            retValue.citizen = this.lsCitizen.FOREIGNER;
          }
        }

        return retValue;
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.C_SEARCH,
          "error in formatSearchObjCitizen",
          err.toString(),
          "formatSearchObjCitizen",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },
    assignDefaultCitizen: function(pdefaultCitizen) {
      try {
        if (BaseConfiguration.isDebug) console.log("assignDefaultCitizen");

        let retCitizen = null;
        // if (pdefaultCitizen == this.lsCitizen.MYANMAR.code || pdefaultCitizen == this.lsCitizen.CANADIAN.code) {
        if (pdefaultCitizen == this.lsCitizen.CITIZEN.code) {
          retCitizen = cloneData(this.lsCitizenCategory[TRIP.ONE_WAY - 1]);
        } else {
          retCitizen = cloneData(this.lsCitizenCategory[TRIP.ONE_WAY]);
        }
        this.onChangedCitizen(retCitizen);

        return retCitizen;
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.C_SEARCH,
          "error in assignDefaultCitizen",
          err.toString(),
          "assignDefaultCitizen",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },
    triggerFlightDatePicker() {
              if (BaseConfiguration.isDebug) console.log("triggerFlightDatePicker");

        this.onToggleBackdrop(true);
        this.closePaxView();
        this.addCssClass();
        if (this.$refs.flightDatePicker.isOpen) {
          this.$refs.flightDatePicker.isOpen = false;
        }
    },
    //to focus departure dropdown
    openDatePicker(){
      if (BaseConfiguration.isDebug) console.log("openDatePicker");
      if (this.isBackdropAdded==true && this.search.route[0].from && this.search.route[0].to) {
        this.$refs.flightDatePicker.isOpen = true;
      }
    },
    triggerDepCityPicker() {
      try {
        if (BaseConfiguration.isDebug) console.log("triggerDepCityPicker");
        /*if (this.search.route[0].from) {
          this.$refs.fromCityPicker.deactivate();
        } else {
          this.$refs.fromCityPicker.deactivate();

          setTimeout(() => {
            this.$refs.fromCityPicker.activate();
          });
        }*/
        //this.$refs.fromCityPicker.activate();
        if (!this.search.route[0].from) {
          this.$refs.fromCityPicker.activate();
        }else{
          this.triggerFlightDatePicker();
        }        
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.C_SEARCH,
          "error in trigger",
          err.toString(),
          "trigger",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },
    ///to focus arrival dropdown
    triggerArrCityPicker() {
      try {
        if (BaseConfiguration.isDebug) console.log("triggerArrCityPicker");
        if(this.isBackdropAdded==true){
            //this.$refs.toCityPicker.activate();
            this.triggerFlightDatePicker();
            //this.$refs.toCityPicker.deactivate();

            //setTimeout(() => {
              this.$refs.toCityPicker.activate();
            //});
        }       
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.C_SEARCH,
          "error in triggerArrCityPicker",
          err.toString(),
          "triggerArrCityPicker",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },
    assigni18nObjByLang() {
      let retValue;
      try {
        if (BaseConfiguration.isDebug) console.log("assigni18nObjByLang");
      
        retValue = {
          night: this.$t("flightDatePicker.night"),
          nights: this.$t("flightDatePicker.nights"),
          "day-names": [
            this.$t("flightDatePicker.sun"),
            this.$t("flightDatePicker.mon"),
            this.$t("flightDatePicker.tue"),
            this.$t("flightDatePicker.wed"),
            this.$t("flightDatePicker.thur"),
            this.$t("flightDatePicker.fri"),
            this.$t("flightDatePicker.sat")
          ],
          "check-in": formatDate( this.search.route[0].date,"ddd, MMM DD"),
          // this.$t("flightDatePicker.checkIn"),
          // "check-out":"",
          "check-out": formatDate(addDays(new Date(this.search.route[0].date),7),"ddd, MMM DD"),
          "month-names": [
            this.$t("flightDatePicker.jan"),
            this.$t("flightDatePicker.feb"),
            this.$t("flightDatePicker.mar"),
            this.$t("flightDatePicker.apr"),
            this.$t("flightDatePicker.may"),
            this.$t("flightDatePicker.jun"),
            this.$t("flightDatePicker.july"),
            this.$t("flightDatePicker.aug"),
            this.$t("flightDatePicker.sep"),
            this.$t("flightDatePicker.oct"),
            this.$t("flightDatePicker.nov"),
            this.$t("flightDatePicker.dec")
          ]
        };
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.C_SEARCH,
          "error in assigni18nObjByLang",
          err.toString(),
          "assigni18nObjByLang",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },

emitSearchObj() {
      try {
        if (BaseConfiguration.isDebug) console.log("emitSearchObj");
        updateDataEdited(false);
      //   if(!this.search.route[0].date){
      //  this.search.route[0].date =new Date();
      //   }

      if(this.search.trip!=TRIP.MULTI_CITY&&!this.isMLSearch){
        this.checkAndEmitValidObj(this.search,this.isMLSearch);

      //  if (this.isValidSearch(this.search)) {

       
      //   let formattedSearchObj = this.formatSearchObjCitizen(this.search);

      //   this.storeSearchHistory(formattedSearchObj,new Date())
      //     this.$emit("send", formattedSearchObj);
      //   }
      }else{
        let mlSearchObj=this.getFormattedMlSearchObj(this.GET_ML_SEARCH_OBJ,this.search);
          this.checkAndEmitValidObj(mlSearchObj,this.isMLSearch);

        //  if (this.isValidSearch(mlSearchObj)) {

       
        // let formattedSearchObj = this.formatSearchObjCitizen(mlSearchObj);
        //  this.SET_ML_SEARCH_OBJ(formattedSearchObj);


        // this.storeSearchHistory(formattedSearchObj,new Date())
        //   this.$emit("send", formattedSearchObj);
        // }
      }
      
        
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.C_SEARCH,
          "error while emitting search object",
          err.toString(),
          "emitSearchObj",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },


    checkAndEmitValidObj(pSearchObj,isMLSearch) {
        try {
          if(BaseConfiguration.isDebug) console.log("checkAndEmitValidObj");
        
           if (this.isValidSearch(pSearchObj)) {
         
      
        let formattedSearchObj = this.formatSearchObjCitizen(pSearchObj);
            this.SET_SEARCH_OBJ(formattedSearchObj);
        if(isMLSearch){
          this.SET_ML_SEARCH_OBJ(formattedSearchObj);
          this.SET_IS_ML_SEARCH(true);

         }else{
           this.SET_IS_ML_SEARCH(false);

         }

        this.storeSearchHistory(formattedSearchObj,new Date())
          this.$emit("send", formattedSearchObj,isMLSearch);
        }
        
    
        } catch (err) {
                let body = Logger.buildRequest(
                   COMPONENT_NAME.C_SEARCH,
                  "error in checkAndEmitValidObj",
                  err.toString(),
                  "checkAndEmitValidObj",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
        
        }, 

    getFormattedMlSearchObj(pMlSearchObj,pSearchObj) {
      let retValue;
        try {
          if(BaseConfiguration.isDebug) console.log("getFormattedMlSearchObj");
       retValue=cloneDeep(pSearchObj);
       retValue.route=cloneDeep(pMlSearchObj.route);
    
        } catch (err) {
                let body = Logger.buildRequest(
                  COMPONENT_NAME.C_SEARCH,
                  "error in getFormattedMlSearchObj",
                  err.toString(),
                  "getFormattedMlSearchObj",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
          return retValue;
        }, 
      
      

    ///to get currency service url
    getOrgCurrencyServiceURL() {
      try {
        if (BaseConfiguration.isDebug) console.log("getCurrencyServiceURL");
        return SERVICE_URL.GET_ORG_CURRENCY;
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.C_SEARCH,
          "error while getting currency  service url",
          err.toString(),
          "getCurrencyServiceURL",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },
    ///to change currency
    onCurrencyChange(selCurrencyObj) {
      try {
        if (BaseConfiguration.isDebug) console.log("onCurrencyChange");

        this.search.currency = selCurrencyObj;        
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.C_SEARCH,
          "error while changing currency",
          err.toString(),
          "onCurrencyChange",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },
    ///to assign airline class to search object
    // onAssignAirlineClass(selectedOption) {
    //   try {
    //     if (BaseConfiguration.isDebug) console.log("onAssignAirlineClass");

    //     this.search.class = selectedOption;
    //   } catch (err) {
    //     let body = Logger.buildRequest(
    //       COMPONENT_NAME.C_SEARCH,
    //       "error while assigning airline class",
    //       err.toString(),
    //       "onAssignAirlineClass",
    //       LOG_TYPE.ERROR
    //     );
    //     Logger.getResponse(body);
    //   }
    // },

    // ///to assign adult count to search object
    // onAssignAdultCount(selectedOption) {
    //   try {
    //     if (BaseConfiguration.isDebug) console.log("onAssignAdultCount");

    //     this.search.pax.adultCount = selectedOption;
    //   } catch (err) {
    //     let body = Logger.buildRequest(
    //       COMPONENT_NAME.C_SEARCH,
    //       "error while assigning adult count",
    //       err.toString(),
    //       "onAssignAdultCount",
    //       LOG_TYPE.ERROR
    //     );
    //     Logger.getResponse(body);
    //   }
    // },

    ///to assign child count to search object
    // onAssignChildCount(selectedOption) {
    //   try {
    //     if (BaseConfiguration.isDebug) console.log("onAssignChildCount");

    //     this.search.pax.childCount = selectedOption;
    //   } catch (err) {
    //     let body = Logger.buildRequest(
    //       COMPONENT_NAME.C_SEARCH,
    //       "error while assigning child count",
    //       err.toString(),
    //       "onAssignChildCount",
    //       LOG_TYPE.ERROR
    //     );
    //     Logger.getResponse(body);
    //   }
    // },

    ///to assign infant count to search object
    onAssignInfantCount(selectedOption) {
      try {
        if (BaseConfiguration.isDebug) console.log("onAssignInfantCount");

        this.search.pax.infantCount = selectedOption;
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.C_SEARCH,
          "error while assigning infant count",
          err.toString(),
          "onAssignInfantCount",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    ///to assign route objects by trip
    assignRouteObjByTrip(pRouteObj, pValue) {
      try {
        if (BaseConfiguration.isDebug) console.log("assignRouteObjByTrip");

        let lsRouteObj = [];
        //this.search.route = [];
        for (var i = 0; i < pValue; i++) {
          let obj = cloneData(pRouteObj);
          if (i == 1) {
            obj.date = addDays(new Date(lsRouteObj[0].date), 7);
            // obj.date = new Date(
            //   new Date().setDate(new Date(lsRouteObj[0].date).getDate() + 7)
            // );
          }
          lsRouteObj.push(obj);
        }
        // lsRouteObj[TRIP.ONE_WAY].date=new Date(new Date().setDate(new Date(lsRouteObj[0].date).getDate() + 7));
        return lsRouteObj;
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.C_SEARCH,
          "error while assigning object",
          err.toString(),
          "assignRouteObjByTrip",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },
     toggleCheckIn(){
// this.$refs.flightDatePicker.setCheckIn(new Date(this.search.route[1].date)); 
// this.$refs.flightDatePicker.startingDateValue=new Date(this.search.route[1].date); 
// this.$refs.flightDatePicker.startDateValue=new Date(this.search.route[1].date); 
// this.$refs.flightDatePicker.handleDayClick();
// this.$refs.flightDatePicker.$emit('check-in-changed', new Date(this.search.route[1].date));
// let date={
//   start: new Date(this.search.route[0].date),
//   end : new Date(this.search.route[0].date)
// };
// this.$refs.flightDatePicker.$emit('update',date);
this.$refs.flightDatePicker.checkIn=new Date(this.search.route[0].date);
this.$refs.flightDatePicker.checkOut=new Date(this.search.route[0].date);
     },

    ///to change trip category based on trip type
    onChangeTripCategory(pTripType) {
      try {

        if (BaseConfiguration.isDebug) console.log("onChangeTripCategory");

        if(this.search.trip==TRIP.MULTI_CITY){
          if(this.GET_ML_SEARCH_OBJ&&this.GET_ML_SEARCH_OBJ.route&&this.GET_ML_SEARCH_OBJ.route[0].from){
         this.search.route=this.GET_ML_SEARCH_OBJ.route;

          }
        }
        let selArrivalRoute=this.search.route[0].to;
         this.search.trip = cloneData(pTripType.code);

       if(pTripType.code!=TRIP.MULTI_CITY){

        this.isMLSearch=false;
        this.isDatePicShow = false;
     
      

        this.search.trip = pTripType.code;
      
        var routeObj = this.search.route[TRIP.ONE_WAY - 1];

        if (this.search.trip == TRIP.MULTI_CITY) {
          ///multiple city
          //handle later
          //   assignObjByTrip(routeObj, 5);
        } else {
          ///oneway or roundTrip

          this.search.route = this.assignRouteObjByTrip(
            routeObj,
            this.search.trip
          );
        }
        let that = this;
        setTimeout(function() {
          that.isDatePicShow = true;
        });
        // this.onClickDatePicker();

        let retSearchObj = this.assignDepToSearch(this.search.route[0].from); ///to save the existing departure while certain trip change
        if (retSearchObj != null) {
          this.search.route = retSearchObj.route;
        } else {
          this.search.route = null;
        }

          if( this.search.trip==TRIP.ONE_WAY){
          // this.search.route[0].date=new Date();
              // this.toggleCheckIn();
        }else{
       this.searchHistory = this.getSearchHistory(this.USER_ID);
      if(this.searchHistory.length>0){
        if(this.searchHistory[this.searchHistory.length-1].search.trip==2){
     this.search.route[0].date=this.searchHistory[this.searchHistory.length-1].search.route[0].date;
      this.search.route[1].date=this.searchHistory[this.searchHistory.length-1].search.route[1].date;

        }
       
      }
        }

        this.assignArrToSearch(this.search.route[0].to); ///to save the existing arrival
        // this.toggleCheckIn();
        this.getArrivalRoutes(this.search.route[0].from);
        this.search.route[0].to=selArrivalRoute;
       }else{
         this.isMLSearch=true;
        //  navigate(PATHNAME.ROUTE)
       }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.C_SEARCH,
          "error while change trip category",
          err.toString(),
          "onChangeTripCategory",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    ///to save departure country value to search object
    assignDepToSearch(depVal) {
      try {
        if (BaseConfiguration.isDebug) console.log("assignDepToSearch");

        var retSearchObj = this.search;
        if (depVal != null) {
          //if 1st selection is departure
          if (retSearchObj.trip == TRIP.ONE_WAY) {
            ///OneWay
            retSearchObj.route[TRIP.ONE_WAY - 1].from = depVal;
          } else if (retSearchObj.trip == TRIP.ROUND_TRIP) {
            //RoundTrip
            retSearchObj.route[TRIP.ONE_WAY - 1].from = depVal;
            retSearchObj.route[TRIP.ONE_WAY].to = depVal;
          } else {
            ///Multiple City -handle later
            retSearchObj.route[TRIP.ONE_WAY - 1].from = depVal;
          }
        }

        // else {
        //   //if 1st selection is arrival
        //   if (arrVal != null) {
        //     if (retSearchObj.trip == TRIP.ONE_WAY) {
        //       ///OneWay
        //       retSearchObj.route[TRIP.ONE_WAY - 1].to = arrVal;
        //     } else if (this.search.trip == TRIP.ROUND_TRIP) {
        //       //RoundTrip
        //       retSearchObj.route[TRIP.ONE_WAY - 1].to = arrVal;
        //       retSearchObj.route[TRIP.ONE_WAY].from = arrVal;
        //     } else {
        //       ///Multiple City -handle later
        //       retSearchObj.route[TRIP.ONE_WAY - 1].to = arrVal;
        //       retSearchObj.route[TRIP.ONE_WAY].from = arrVal;
        //     }
        //   } else {
        //     retSearchObj.route[TRIP.ONE_WAY - 1].to = null;
        //   }
        // }
        return retSearchObj;
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.C_SEARCH,
          "error while assigning departure value to search",
          err.toString(),
          "assignDepToSearch",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    ///to assign arrival country value to search object
    assignArrToSearch(arrVal) {
      try {
        if (BaseConfiguration.isDebug) console.log("assignArrToSearch");
        var searchObj = this.search;
        if (arrVal != null) {
          if (searchObj.trip == TRIP.ONE_WAY) {
            ///oneway
            searchObj.route[TRIP.ONE_WAY - 1].to = arrVal;
          } else if (this.search.trip == TRIP.ROUND_TRIP) {
            ///roundtrip
            searchObj.route[TRIP.ONE_WAY - 1].to = arrVal;
            searchObj.route[TRIP.ONE_WAY].from = arrVal;
          } else {
            ///multiple city
            searchObj.route[TRIP.ONE_WAY - 1].to = arrVal;
          }
        } else {
          searchObj.route[TRIP.ONE_WAY - 1].to = null;
        }
        this.search.route = searchObj.route;
        // return searchObj;
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.C_SEARCH,
          "error while assigning arrival value to search",
          err.toString(),
          "assignArrToSearch",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    // //to navigate to search result page
    // navToResultPage() {
    //   try {
    //     if (BaseConfiguration.isDebug) console.log("navToResultPage");
    //     this.SET_SEARCH_OBJ(this.search);

    //     if (this.storeSearchHistory(this.search)) {
    //       navigate(
    //         path: PATHNAME.FLIGHTRESULTS
    //         // query: {
    //         //   param: [retSearchResult]
    //         // }
    //       });
    //     }
    //   } catch (err) {
    //     let body = Logger.buildRequest(
    //       FILE_NAME.SEARCHPAGE,
    //       "error while navigation",
    //       err.toString(),
    //       "navToResultPage",
    //       LOG_TYPE.ERROR
    //     );
    //     Logger.getResponse(body);
    //   }
    // },

    ///to get list of search results from api
    // async getSearchResponse(pSearchObj) {
    //   let retValue;
    //   try {
    //     if (BaseConfiguration.isDebug) console.log("getSearchResponse");

    //     let getSearchRequest = apiSearchResult.buildRequest(pSearchObj);

    //     if (getSearchRequest) {
    //       // this.SET_AGENCY_REQ(getRoutesRequest); //save req in store
    //       let getSearchResponse = await apiSearchResult.getResponse(
    //         getSearchRequest
    //       );

    //       if (VALIDATE_SUCCESS_RES(getSearchResponse)) {
    //         // this.SET_AGENCY_RES(getRoutesResponse); //save res in store

    //         retValue = getSearchResponse.data.data;
    //       } else {

    //         let error = getErrorMessage(getSearchResponse);

    //                 let isJwt = handleJWT(error);
    //                 if (!isJwt) {
    //                     this.alertValue = getErrorAlertValue(error)
    //                 }

    //       }
    //     }
    //   } catch (err) {
    //     let body = Logger.buildRequest(
    //       COMPONENT_NAME.C_SEARCH,
    //       "error in getting response from get search result response API",
    //       err.toString(),
    //       "getSearchResponse",
    //        LOG_TYPE.ERROR
    //     );
    //       Logger.getResponse(body);
    //   }
    //   return retValue;
    // },

    ///to get changed citizen category that emit from CRadio
    onChangedCitizen(value) {
      try {
        if (BaseConfiguration.isDebug) console.log("onChangedCitizen");

        // this.selectedCCategory = value;
        this.citizenObj = value;
        let currencyCode;
        if(this.citizenObj.code==this.lsCitizenCategory[0].code){
          currencyCode=BaseConfiguration.defaultCurrencyObj.code;
        }else if(this.citizenObj.code==this.lsCitizenCategory[1].code){
          currencyCode=BaseConfiguration.defaultForeignCurrencyCode;
        }

        let currencyObj;
        if(this.currencyOptions){
         
          for (let index = 0; index < this.currencyOptions.length; index++) {
            const curr = this.currencyOptions[index];
            if(curr.currency_code.code==currencyCode)
            currencyObj=curr;
          }
        } 
        this.onCurrencyChange(currencyObj);
       
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.C_SEARCH,
          "error while getting changed category of citizen",
          err.toString(),
          "onChangedCitizen",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    ///to get number of counts for each pax category
    getPaxCategoryCount(category) {
      try {
        if (BaseConfiguration.isDebug) console.log("getPaxCategoryCount");

        let retValue = [];
        for (let i = 0; i < 11; i++) {
          retValue.push(i);
        }
        return retValue;
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.C_SEARCH,
          "error while getting pax count ",
          err.toString(),
          "getPaxCategoryCount",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },
    ///to get departure date
    getFromDate(selectedDate) {
      try {
        if (BaseConfiguration.isDebug) console.log("getFromDate");
        this.search.route[0].date = selectedDate;
        this.onToggleBackdrop(false);  
        // console.log(this.$refs.flightDatePicker)      
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.C_SEARCH,
          "error in getFromDate ",
          err.toString(),
          "getFromDate",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    ///to get arrival date
    getToDate(selectedDate) {
      try {
        if (BaseConfiguration.isDebug) console.log("getToDate");
        if (this.search.trip == TRIP.ROUND_TRIP) {
          if(selectedDate){
          this.search.route[1].date = selectedDate;
         
          }
           else{
            // this.getCheckOut();
            //if( this.$refs.flightDatePicker.isOpen==true){
             this.search.route[1].date= addDays(new Date(this.search.route[0].date),7);
           // }
          //     this.$refs.flightDatePicker.checkOut= this.search.route[1].date
          // //      this.isDatePicShow=false;
        
          // //   let that = this;
          // //   setTimeout(function() {
          // //   that.isDatePicShow = true;
          // // },100);
           }
          this.onToggleBackdrop(false);          
        }        
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.C_SEARCH,
          "error in getToDate ",
          err.toString(),
          "getToDate",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    ///to get number of routes response from api
    async getRoutesResponse() {
      let retValue;
      try {
        if (BaseConfiguration.isDebug) console.log("getRoutesResponse");

        let getRoutesRequest = apiGetRoutes.buildRequest();

        if (getRoutesRequest) {
          // this.SET_AGENCY_REQ(getRoutesRequest); //save req in store
          let getRouteResponse = await apiGetRoutes.getResponse(
            getRoutesRequest
          );

          if (VALIDATE_SUCCESS_RES(getRouteResponse)) {
            // this.SET_AGENCY_RES(getRoutesResponse); //save res in store

            retValue = getRouteResponse.data.data;
            this.SET_ROUTES_OBJ(retValue);
          } else {
            let error = getErrorMessage(getRouteResponse);

            let isJwt = handleJWT(error);
            if (!isJwt) {
              this.alertValue = getErrorAlertValue(error);
            }
          }
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.C_SEARCH,
          "error while getting response from get Routes response API",
          err.toString(),
          "getRoutesResponse",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },

    ///method to get routes for particular country
    getRoutesByCountryCode() {
      try {
        if (BaseConfiguration.isDebug) console.log("getRoutesByCountryCode");

        // this.lsCountryRoute = []; //to clear the list

        let countries = this.routesResponse.countries;
        let airports = this.routesResponse.airports;
        let routes = this.routesResponse.routes;
        let listOfRoutes = [];

        var routesGrpByList = GroupByList(routes, "depcode", "arrCombination"); ///list of routes grouped by depcode
        for (let i = 0; i < Object.keys(countries).length; i++) {
          for (let j = 0; j < Object.keys(airports).length; j++) {
            let lsArrCodes = [];
            if (
              Object.values(countries)[i].countrycode ==
              Object.values(airports)[j].countryid
            ) {
              for (let k = 0; k < routesGrpByList.length; k++) {
                if (
                  routesGrpByList[k].depcode ==
                  Object.values(airports)[j].airportcode
                ) {
                  for (
                    let l = 0;
                    l < routesGrpByList[k].arrCombination.length;
                    l++
                  ) {
                    lsArrCodes.push(
                      routesGrpByList[k].arrCombination[l].arrcode
                    );
                  }
                }
              }
             
              let lsArrCodesForDep = {
                // "routes": 1,
                depcode: Object.values(airports)[j],
                arrcode: lsArrCodes
              }; ///list of arrival for particular departure

              listOfRoutes.push(lsArrCodesForDep); ///list of routes for particular country
            }
          }

          let countryRoute = {
            country: Object.values(countries)[i],
            routeList: listOfRoutes
          };
          listOfRoutes = [];
          this.lsCountryRoute.push(countryRoute);
        }
        let startCountry = cloneData(this.lsCountryRoute[0]);
        for (let index = 0; index < this.lsCountryRoute.length; index++) {
          const countryObj = this.lsCountryRoute[index];
          if(countryObj.country.countrycode==BaseConfiguration.defaultCountryValue){
            this.lsCountryRoute[0]=countryObj;
            this.lsCountryRoute[index]=startCountry;
            break;
          }
          
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.C_SEARCH,
          "error while formatting routes",
          err.toString(),
          "getRoutesByCountryCode",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },
    // getArrRoutesByCountryCode() {
    //   try {
    //     if (BaseConfiguration.isDebug) console.log("getArrRoutesByCountryCode");

    //     // this.lsCountryRoute = []; //to clear the list

    //     let countries = this.routesResponse.countries;
    //     let airports = this.routesResponse.airports;
    //     let routes = this.routesResponse.routes;
    //     let listOfRoutes = [];

    //     var routesGrpByList = GroupByList(routes, "arrcode", "depCombination"); ///list of routes grouped by arrcode
    //       this.tempRoutesGrpByList=routesGrpByList;

    //     for (let i = 0; i < Object.keys(countries).length; i++) {
    //       for (let j = 0; j < Object.keys(airports).length; j++) {
    //         let lsDepCodes = [];
    //         if (
    //           Object.values(countries)[i].countrycode ==
    //           Object.values(airports)[j].countryid
    //         ) {
    //           for (let k = 0; k < routesGrpByList.length; k++) {
    //             if (
    //               routesGrpByList[k].arrcode ==
    //               Object.values(airports)[j].airportcode
    //             ) {
    //               for (
    //                 let l = 0;
    //                 l < routesGrpByList[k].depCombination.length;
    //                 l++
    //               ) {
    //                 lsDepCodes.push(
    //                   routesGrpByList[k].depCombination[l].depcode
    //                 );
    //               }
    //             }
    //           }

    //           let lsArrCodesForDep = {
    //             // "routes": 1,
    //             arrcode: lsDepCodes,
    //             depcode: Object.values(airports)[j]
    //           }; ///list of arrival for particular departure

    //           listOfRoutes.push(lsArrCodesForDep); ///list of routes for particular country
    //         }
    //       }

    //       let countryRoute = {
    //         country: Object.values(countries)[i],
    //         routeList: listOfRoutes
    //       };
    //       listOfRoutes = [];
    //       this.lsArrival.push(countryRoute);
    //     }
    //   } catch (err) {
    //     let body = Logger.buildRequest(
    //       COMPONENT_NAME.C_SEARCH,
    //       "error while formatting routes",
    //       err.toString(),
    //       "getArrRoutesByCountryCode",
    //       LOG_TYPE.ERROR
    //     );
    //     Logger.getResponse(body);
    //   }
    // },

    // getDepartureRoutes(pValue) {
    //   try {
    //     if (BaseConfiguration.isDebug) console.log("getDepartureRoutes");
    //     // this.isRouteChanged = false;

    //     // this.lsCountryRoute = []; //to clear the list

    //     let countries = this.routesResponse.countries;
    //     let airports = this.routesResponse.airports;
    //     let routes = this.routesResponse.routes;
    //     let listOfRoutes = [];

    //     var routesGrpByList = GroupByList(routes, "depcode", "arrCombination"); ///list of routes grouped by depcode

    //     // for (let i = 0; i < Object.keys(countries).length; i++) {
    //     //   for (let j = 0; j < Object.keys(airports).length; j++) {
    //         let lsArrCodes = [];
    //         // if (
    //         //   pValue.depcode.countrycode ==
    //         //   Object.values(airports)[j].countryid
    //         // ) {
    //           for (let k = 0; k < routesGrpByList.length; k++) {
    //             if (
    //               routesGrpByList[k].depcode ==
    //               pValue.depcode.airportcode
    //             ) {
    //               for (
    //                 let l = 0;
    //                 l < routesGrpByList[k].arrCombination.length;
    //                 l++
    //               ) {
    //                 lsArrCodes.push(
    //                   routesGrpByList[k].arrCombination[l].arrcode
    //                 );
    //               }
    //             }

    //           }

    //           let lsArrCodesForDep = {
    //             // "routes": 1,
    //             depcode: Object.values(airports)[j],
    //             arrcode: lsArrCodes
    //           }; ///list of arrival for particular departure

    //           listOfRoutes.push(lsArrCodesForDep); ///list of routes for particular country
    //        // }

    //     //   let countryRoute = {
    //     //     country: Object.values(countries)[i],
    //     //     routeList: listOfRoutes
    //     //   };
    //     //   listOfRoutes = [];
    //     //   this.lsCountryRoute.push(countryRoute);
    //     // }
    //   } catch (err) {
    //     let body = Logger.buildRequest(
    //       FILE_NAME.filename,
    //       "error in getDepartureRoutes",
    //       err.toString(),
    //       "getDepartureRoutes",
    //       LOG_TYPE.ERROR
    //     );
    //     Logger.getResponse(body);
    //   }
    // },

   getArrivalCodesForDep(pDepObj) {
      let retValue=[];
       try {
         if(BaseConfiguration.isDebug) console.log("getArrivalCodesForDep");
         let lsCountryRoute=cloneData(this.lsCountryRoute);
         for(let i=0;i<lsCountryRoute.length;i++){
           if(lsCountryRoute[i].country.countrycode==pDepObj.countryid){
             for(let j=0;j<lsCountryRoute[i].routeList.length;j++){
               if(lsCountryRoute[i].routeList[j].depcode.airportcode==pDepObj.airportcode){
                 retValue=lsCountryRoute[i].routeList[j].arrcode;
                 break;
               }
             }
           }
         }
       } catch (err) {
               let body = Logger.buildRequest(
                  COMPONENT_NAME.C_SEARCH,
                 "error in getArrivalCodesForDep",
                 err.toString(),
                 "getArrivalCodesForDep",
                 LOG_TYPE.ERROR
               );
               Logger.getResponse(body);
             }
         return retValue;
       }, 
    ///to get list of arrival routes
    getArrivalRoutes(pValue) {
      try {
        if (BaseConfiguration.isDebug) console.log("getArrivalRoutes");
        // this.isRouteChanged = false;
        let lsOfRouteArrival = [];
        if(this.routesResponse!=null){
        let countries = this.routesResponse.countries;
        let airports = this.routesResponse.airports;
        let listOfRoutes = [];
        var airGrpByList = GroupByList(airports, "countryid", "arrCombination"); ///list of routes grouped by depcode

        if (pValue&&pValue.arrcode.length > 0) {
          if (this.lsArrival.length > 0) {
            // this.lsCountryRoute = [];
            this.lsArrival = []; //to clear the list
          }
          //  for (let i = 0; i < pValue.arrcode.length; i++) {
              for (let i = 0; i < airGrpByList.length; i++) {
                listOfRoutes=[];
                for (let j = 0; j < pValue.arrcode.length; j++) {
                 if (
                  airGrpByList[i].countryid ==airports[pValue.arrcode[j]].countryid
                  
                ) {
                     let lsArrCodesForDep = {
              // "routes": 1,
              depcode: airports[pValue.arrcode[j]],
              arrcode:this.getArrivalCodesForDep(airports[pValue.arrcode[j]]),
            }; 
            // this.getArrivalCodesForDep(airports[pValue.arrcode[j]])
              listOfRoutes.push(lsArrCodesForDep);

                }
                }
              if(listOfRoutes.length>0)
              {
                let countryRoute = {
              country: countries[airGrpByList[i].countryid],
              routeList: listOfRoutes
            };
             lsOfRouteArrival.push(countryRoute);
              }
             
              }
         

          this.lsArrival = lsOfRouteArrival;
          // console.log( this.lsArrival);
          // console.log( this.lsCountryRoute);
          this.SET_ARR_LS(this.lsArrival);
          this.search.route[0].to = null;

          let retSearchObj = this.assignDepToSearch(this.search.route[0].from);
          if (retSearchObj != null) {
            this.search.route = retSearchObj.route;
          } else {
            this.search.route = null;
          }

          this.assignArrToSearch(this.search.route[0].to);

          // console.log(lsOfRouteArrival);

          // if (this.search.route[0].from == null) {
          //   this.lsCountryRoute = lsOfRouteArrival;
          // } else {
          //   this.search.route[0].to = null;
          //   this.getRoutesByCountryCode();
          // }
        } else {
          // this.getRoutesByCountryCode();

            ///to clear the existing arrivals 
          this.lsArrival = [];
          this.SET_ARR_LS(this.lsArrival);
        
        }
  
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.C_SEARCH,
          "error while formatting routes",
          err.toString(),
          "getArrivalRoutes",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    // to validate search
    isValidSearch(pSearch) {
      if (BaseConfiguration.isDebug) console.log("isValidSearch");
      try {
        let retValue = false;
        if (pSearch.trip == TRIP.ONE_WAY) {
          if (pSearch.route && pSearch.route.length == TRIP.ONE_WAY) {
            if (
              pSearch.route[TRIP.ONE_WAY - 1].from != null &&
              pSearch.route[TRIP.ONE_WAY - 1].to != null &&
              pSearch.route[TRIP.ONE_WAY - 1].from.depcode.airportcode !== pSearch.route[TRIP.ONE_WAY - 1].to.depcode.airportcode
            ) {
              if (
                getDiffBtwDates(
                  new Date(pSearch.route[TRIP.ONE_WAY - 1].date),
                  new Date(),
                  "days"
                ) >= 0
              ) {
                if (this.currencyValidation(pSearch)) {
                  retValue = this.paxValidation(pSearch);
                } else {
                  retValue = false;
                  this.showAlertMessage(this.$t("searchPage.selectCurrency"));
                }
              } else {
                retValue = false;
                this.showAlertMessage(this.$t("searchPage.dateInvalid"));
              }
            } else {
              retValue = false;
              this.showAlertMessage(this.$t("searchPage.routeInvalid"));
            }
          } else {
            retValue = false;
            this.showAlertMessage(this.$t("searchPage.routeLengthInvalid"));
          }
        } else if (pSearch.trip == TRIP.ROUND_TRIP) {
          if (pSearch.route && pSearch.route.length == TRIP.ROUND_TRIP) {
            if (
              pSearch.route[TRIP.ROUND_TRIP - 2].from != null &&
              pSearch.route[TRIP.ROUND_TRIP - 2].to != null &&
              pSearch.route[TRIP.ROUND_TRIP - 2].from.depcode.airportcode !== pSearch.route[TRIP.ROUND_TRIP - 2].to.depcode.airportcode
            ) {
              if (
                pSearch.route[TRIP.ROUND_TRIP - 1].from != null &&
                pSearch.route[TRIP.ROUND_TRIP - 1].to != null &&
                pSearch.route[TRIP.ROUND_TRIP - 1].from.depcode.airportcode !== pSearch.route[TRIP.ROUND_TRIP - 1].to.depcode.airportcode
              ) {
                if (
                  getDiffBtwDates(
                    new Date(pSearch.route[TRIP.ROUND_TRIP - 1].date),
                    new Date(pSearch.route[TRIP.ROUND_TRIP - 2].date),
                    "days"
                  ) >= 0
                ) {
                  if (this.currencyValidation(pSearch)) {
                    retValue = this.paxValidation(pSearch);
                  } else {
                    retValue = false;
                    this.showAlertMessage(this.$t("searchPage.selectCurrency"));
                  }
                } else {
                  retValue = false;
                  this.showAlertMessage(
                    this.$t("searchPage.returnDateInvalid")
                  );
                }
              } else {
                retValue = false;
                this.showAlertMessage(this.$t("searchPage.routeInvalid"));
              }
            } else {
              retValue = false;
              this.showAlertMessage(this.$t("searchPage.routeInvalid"));
            }
          } else {
            retValue = false;
            this.showAlertMessage(this.$t("searchPage.routeLengthInvalid"));
          }
        }else if(pSearch.trip == TRIP.MULTI_CITY) {
          if (pSearch.route ) {
            for(let i=0;i<pSearch.route.length;i++){
                
            if (
              pSearch.route[i].from != null &&
              pSearch.route[i].to != null &&
              pSearch.route[i].from.depcode.airportcode !== pSearch.route[i].to.depcode.airportcode
            ) {
              if (
                getDiffBtwDates(
                  new Date(pSearch.route[i].date),
                  new Date(),
                  "days"
                ) >= 0
              ) {
                if (this.currencyValidation(pSearch)) {
                  retValue = this.paxValidation(pSearch);
                } else {
                  retValue = false;
                  this.showAlertMessage(this.$t("searchPage.selectCurrency"));
                }
              } else {
                retValue = false;
                this.showAlertMessage(this.$t("searchPage.dateInvalid"));
              }
            } else {
              retValue = false;
              this.showAlertMessage(this.$t("searchPage.routeInvalid"));
            }
            }
          } else {
            retValue = false;
            this.showAlertMessage(this.$t("searchPage.routeLengthInvalid"));
          }
        }
        
        
        
        else {
          retValue = false;
          this.showAlertMessage(this.$t("searchPage.tripInvalid"));
        }
        return retValue;
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.C_SEARCH,
          "error in isValidSearch",
          err.toString(),
          "isValidSearch",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    ///to validate a currency(if currency slected or not)
    currencyValidation(pSearch) {
      try {
        if (BaseConfiguration.isDebug) console.log("currencyValidation");

        let retValue;
        if (pSearch.currency) {
          if (pSearch.currency.currency_code) {
            if (pSearch.currency.currency_code.code) {
              retValue = true;
            } else {
              retValue = false;
            }
          } else {
            retValue = false;
          }
        } else {
          retValue = false;
        }
        return retValue;
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.C_SEARCH,
          "error in currencyValidation",
          err.toString(),
          "currencyValidation",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    //to valid pax counts(Adult,child,Infant)
    paxValidation(pSearch) {
      try {
        if (BaseConfiguration.isDebug) console.log("paxValidation");

        let retValue;
        if((Number(pSearch.pax.adultCount)+Number(pSearch.pax.childCount)+Number(pSearch.pax.infantCount))<=9){
        if (pSearch.pax.adultCount >= PAX_COUNT.MIN_ADULT) {
          if (
            pSearch.pax.adultCount <= PAX_COUNT.MAX_ADULT &&
            pSearch.pax.childCount <= PAX_COUNT.MAX_CHILD &&
            pSearch.pax.infantCount <= PAX_COUNT.MAX_INFANT
          ) {
            if (pSearch.pax.adultCount >= pSearch.pax.infantCount) {
              retValue = true;
            } else {
              retValue = false;
              this.showAlertMessage(this.$t("searchPage.infantEqualToAdult"));
            }
          } else {
            retValue = false;
            this.showAlertMessage(this.$t("searchPage.maxPax"));
          }
        } else {
          retValue = false;
          this.showAlertMessage(this.$t("searchPage.minAdult"));
        }
        }else{
          retValue = false;
          this.showAlertMessage(this.$t("searchPage.maxPax"));
        }

        return retValue;
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.C_SEARCH,
          "error in paxValidation",
          err.toString(),
          "paxValidation",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    // to show alert message
    showAlertMessage(value ,isRemove) {
      try {
        if (BaseConfiguration.isDebug) console.log("showAlertMessage");
        if (value) {
          // this.showAlert = true;
          this.alertValue = value;
          this.currentAlertCounter = BaseConfiguration.defaultAlertCounter;
        }
        else if(isRemove)
        {
          this.alertValue=null
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.C_SEARCH,
          "error in showAlertMessage",
          err.toString(),
          "showAlertMessage",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },
    //to store search history in localstorage
    storeSearchHistory(pSearch,pDate) {
      if (BaseConfiguration.isDebug) console.log("storeSearchHistory");
      try {
        let retValue = false;
        let userId;
           if (this.USER_ID) {
           userId = this.USER_ID;
           }
        if (pSearch) {
          //let obj = cloneData(this.search);
          let obj ={
            search :  JSON.parse(JSON.stringify(pSearch)),
            searchedDate: pDate
          }
           let searchHistory = this.getSearchHistory(userId);
          //  for(let i=10;i<=searchHistory.length;i++){
          //    searchHistory.shift();
          //  }
          if(searchHistory){
          if(searchHistory.length>=BaseConfiguration.flightSearchHistoryMaxLimit)
            searchHistory.shift();
            searchHistory.push(obj);
        setFlightSearchHisToLocal(
        JSON.stringify(searchHistory),userId
          );
          }
          retValue = true;
        }
        // else throw "invalid Search";
        return retValue;
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.C_SEARCH,
          "error in storeSearchHistory",
          err.toString(),
          "storeSearchHistory",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

     getSearchHistory(pUserId) {
      if (BaseConfiguration.isDebug) console.log("getSearchHistory");
      try {
        let sHistory=[];
       if(pUserId){
        let history = JSON.parse(
           getFlightSearchHisFromLocal(pUserId)
          );
          
          if(history && history.length>0){
            sHistory = history
          }
       }
        return sHistory;
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.SEARCHPAGE,
          "error in getSearchHistory",
          err.toString(),
          "getSearchHistory",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    rotate() {
       if (BaseConfiguration.isDebug) console.log("rotate"); 
      // var element = document.getElementById("rotate-icon");
      // element.classList.toggle("re-rotate");
      this.toggleFlIcon();
     this.search=this.swapCity(this.search);     
    },

    toggleFlIcon(){
      this.isFlIconRotate = !this.isFlIconRotate;

    },

    swapCity(pSearch) {
      let searchObj=pSearch;
        try {
          if(BaseConfiguration.isDebug) console.log("swapCity");
         // let retValue;
          if (searchObj && searchObj.route[0].from&&searchObj.route[0].to){
            let toPlace=cloneData( searchObj.route[0].from);
            let fromPlace=pSearch.route[0].to;
            depListIndex:
      for (let index = 0; index < this.lsCountryRoute.length; index++) {
        const depList = this.lsCountryRoute[index].routeList;
        depIndex:
        for (let index = 0; index < depList.length; index++) {
          const dep = depList[index];
          if(dep.depcode.airportcode == fromPlace.depcode.airportcode){
            searchObj.route[0].from = dep;
            this.getArrivalRoutes( searchObj.route[0].from)
            break depListIndex;
          }
        }        
      }
     // let toPlace=pSearch.route[0].to;
       for (let index = 0; index < this.lsArrival.length; index++) {
        const arrList = this.lsArrival[index].routeList;
        for (let index = 0; index < arrList.length; index++) {
          const arr = arrList[index];
          if(arr.depcode.airportcode == toPlace.depcode.airportcode){
            searchObj.route[0].to = arr;
            this.assignArrToSearch( searchObj.route[0].to)
          }
        }
        
      }
       }else{
         this.toggleFlIcon();
       }
    
        } catch (err) {
                let body = Logger.buildRequest(
                  FILE_NAME.C_SEARCH,
                  "error in swapCity",
                  err.toString(),
                  "swapCity",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
          return searchObj;
        }, 
        
        checkIsMlSearchObj(pSearch) {
          let retValue=false;
            try {
              if(BaseConfiguration.isDebug) console.log("checkIsMultiCiy");
            if(pSearch&&pSearch.trip&&pSearch.trip==TRIP.MULTI_CITY){
             
                retValue=true;
              
            }
        
            } catch (err) {
                    let body = Logger.buildRequest(
                      COMPONENT_NAME.C_SEARCH,
                      "error in checkIsMultiCiy",
                      err.toString(),
                      "checkIsMultiCiy",
                      LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                  }
              return retValue;
            }, 
            getValidRoute(pSearchObj,pRouteResponse) {
              let retValue;
                try {
                  if(BaseConfiguration.isDebug) console.log("getValidRoute");
                  let searchObj=cloneData(pSearchObj);
                  if(pSearchObj&&pSearchObj.route&&pRouteResponse&&pRouteResponse.airports){
                  for(let i=0;i<pSearchObj.route.length;i++){
                    if(!(pSearchObj.route[i]&&pSearchObj.route[i].from&&pSearchObj.route[i].to&&pSearchObj.route[i].from.depcode&&
                    pSearchObj.route[i].to.depcode&&
                    pRouteResponse.airports[pSearchObj.route[i].from.depcode.airportcode]&&
                    pRouteResponse.airports[pSearchObj.route[i].to.depcode.airportcode])){
                     //to set all routes  null if any one route not exist
                      for(let j=0;j< searchObj.route.length;j++){
                      searchObj.route[j].from=null;
                      searchObj.route[j].to=null;
                      }
                      break;
                    }
                    }
                    }
                 retValue=searchObj;
            
                } catch (err) {
                        let body = Logger.buildRequest(
                          COMPONENT_NAME.C_SEARCH,
                          "error in getValidRoute",
                          err.toString(),
                          "getValidRoute",
                          LOG_TYPE.ERROR
                        );
                        Logger.getResponse(body);
                      }
                return retValue;
                }, 

      

  
  },

  computed: {
     ...mapGetters("sCMultiCitySearch", {
      GET_ML_SEARCH_OBJ: "GET_ML_SEARCH_OBJ"
    }),
    ...mapGetters("language", {
      lang: "GET_LANGUAGE"
    }),
    ...mapGetters("sCSearch", {
      searchStoreObj: "GET_SEARCH_OBJ"
    }),
    ...mapGetters("sCSearch", {
      arrStoreLs: "GET_ARR_LS"
    }),

    ...mapGetters("sCSearch", {
      routeObj: "GET_ROUTES_OBJ"
    }),
     ...mapGetters("sCOrgCurrencyDp", {
      currencyOptions: "GET_CURRENCY_OPTIONS",
     
    }),
     ...mapGetters("sCurrencyLs", {
      GET_ORG_CURRENCY_RES: "GET_ORG_CURRENCY_RES"
    }),
    // ...mapGetters("sDashBoard", {
    //   AGENT_DET: "GET_AGENT_LOGO_DET_RES"
    // })
    ...mapGetters("sDashBoard", {
      USER_ID: "GET_USER_ID"
    })
    
  },
  async created() {
    try {
     
      //var a = document.getElementsByClassName("multiselect__option--disabled");
      //a.parentNode.classList.add("active");
      if (BaseConfiguration.isDebug) console.log("created");

      this.defaultCurrencyCode=BaseConfiguration.defaultCitizen==this.lsCitizen.CITIZEN.code?
      BaseConfiguration.defaultCurrencyObj.code:BaseConfiguration.defaultForeignCurrencyCode;

       if(this.searchObject){
      this.search = cloneDeep(this.searchObject);

      if(this.search&&this.search.citizen){
      // if(this.search.citizen.code==this.lsCitizen.MYANMAR.code || this.search.citizen.code==this.lsCitizen.CANADIAN.code){
      if(this.search.citizen.code==this.lsCitizen.CITIZEN.code){
        this.citizenObj=cloneData(this.lsCitizenCategory[TRIP.ONE_WAY - 1]);
      }else if(this.search.citizen.code==this.lsCitizen.FOREIGNER.code){
      this.citizenObj = cloneData(this.lsCitizenCategory[TRIP.ONE_WAY])
      }
      }else{
        //  if (BaseConfiguration.defaultCitizen == this.lsCitizen.MYANMAR.code || BaseConfiguration.defaultCitizen == this.lsCitizen.CANADIAN.code) {
          if (BaseConfiguration.defaultCitizen == this.lsCitizen.CITIZEN.code) {
          this.citizenObj = cloneData(this.lsCitizenCategory[TRIP.ONE_WAY - 1]);
            } else {
          this.citizenObj = cloneData(this.lsCitizenCategory[TRIP.ONE_WAY]);
           }

      }
     
      this.isMLSearch=this.checkIsMlSearchObj( this.search);
    
      }
      else{
      if (this.searchStoreObj != null) {
        this.search = cloneDeep(this.searchStoreObj);
         if(this.search&&this.search.citizen){
           if(this.search.citizen.code==this.lsCitizen.CITIZEN.code){
        // if(this.search.citizen.code==this.lsCitizen.MYANMAR.code ||this.search.citizen.code==this.lsCitizen.CANADIAN.code){
        this.citizenObj=cloneData(this.lsCitizenCategory[TRIP.ONE_WAY - 1]);
      }else if(this.search.citizen.code==this.lsCitizen.FOREIGNER.code){
      this.citizenObj = cloneData(this.lsCitizenCategory[TRIP.ONE_WAY])
      }
         }

          this.isMLSearch=this.checkIsMlSearchObj( this.search);
      } else {
        if (BaseConfiguration.defaultTrip == TRIP.ROUND_TRIP) {
          ///if round trip
          let pRouteObj = this.search.route[TRIP.ONE_WAY - 1];
          let obj = cloneData(pRouteObj);
          obj.date = addDays(new Date(obj.date), 7);

          this.search.route.push(obj);
        }
          // if (this.search&&this.search.citizen&&this.search.citizen.code?this.search.citizen.code:BaseConfiguration.defaultCitizen == this.lsCitizen.MYANMAR.code) {
         if (this.search&&this.search.citizen&&this.search.citizen.code?this.search.citizen.code:BaseConfiguration.defaultCitizen == this.lsCitizen.CITIZEN.code) {
          this.citizenObj = cloneData(this.lsCitizenCategory[TRIP.ONE_WAY - 1]);
            } else {
          this.citizenObj = cloneData(this.lsCitizenCategory[TRIP.ONE_WAY]);
           }

        this.isMLSearch= this.checkIsMlSearchObj( this.search);
      }
     
      }

    
     
      if (this.routeObj != null) {
        this.routesResponse = this.routeObj;
      } else {
        this.routesResponse = await this.getRoutesResponse();
      }
      if (this.routesResponse != null) {
        this.getRoutesByCountryCode();
        if(this.arrStoreLs.length>0){
        this.lsArrival = this.arrStoreLs;
        }else{
          if(this.search&&this.search.route&&this.search.route[0].from)
          this.getArrivalRoutes(this.search.route[0].from);
         
          if(this.searchObject&&this.searchObject.route){
           this.search.route[0].to=cloneDeep(this.searchObject.route[0].to);

          }
        }
        this.search=this.getValidRoute(this.search,this.routesResponse);
      }
    
    } catch (err) {
      let body = Logger.buildRequest(
        COMPONENT_NAME.C_SEARCH,
        "error while created",
        err.toString(),
        "created",
        LOG_TYPE.ERROR
      );
      Logger.getResponse(body);
    }
  }
};

// script for toggle animation
</script>


<style>
.slide-fade-enter-active {
  transition: all 0.3s ease;
}

.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter,
.slide-fade-leave-to {
  transform: translateX(10px);
  opacity: 0;
}

.test {
  background-color: rgb(167, 195, 218);
}

.nav-tabs .nav-link.active,
.nav-tabs .nav-item.show .nav-link {
  color: #ffffff;
  background-color: #3e2ddd;
  border-color: #0f0096;
}

.radioOptions {
  padding: 5px;
}
.align-alert{
  padding-left: 5px;
}
</style>
